import FormInputCapitalized from './FormInputCapitalized'

export default FormInputCapitalized
